import React, { useState, useEffect } from "react";
import WhiteQuestionMark from "src/assets/svgs/Questionmark.svg";
import * as styles from "./style.mod.scss";
import { duration } from "helpers/duration-helpers";
import locale from "locales";

const Countdown = ({ timer, title, message }) => {
  let interval = null;
  const [timeLeft, setTimeLeft] = useState(duration(`${timer}`));
  const [open, setOpen] = useState(false);
  const countdownLoc = locale.countdown;

  useEffect(() => {
    interval = setInterval(() => {
      setTimeLeft(duration(`${timer}`));

    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const { days, hours, minutes, seconds } = timeLeft;

  if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
    clearInterval(interval);
  }

  return (
    <div className={styles.timer}>
      {(days > 0 || hours > 0 || minutes > 0 || seconds > 0) && (
        <>
          <div className={styles.countdownContainer}>
            {message &&
              <p className={styles.smallTitle} onClick={() => setOpen(!open)}>{title}{<WhiteQuestionMark onMouseEnter={() => setOpen(true)}
                onMouseLeave={() => setOpen(false)} />}
              {open &&
                  <div className={styles.messageModal}>
                    <div className={styles.modalBox} >
                      <div className={styles.triangle}></div>
                      <div className={styles.content}>
                        <span>{message}</span>
                      </div>
                    </div>
                  </div>
              }
              </p>}
            <div className={styles.countdown}>
              <div className={`${styles.smallContainer} ${styles.container}`}>
                <span className={styles.smallNumber}>
                  {days.toFixed(0).padStart(2, "0")}
                </span>
                <span className={styles.smallText}>{countdownLoc.abbrDay}</span>
              </div>
              <div className={`${styles.smallContainer} ${styles.container}`}>
                <span className={styles.smallNumber}>
                  {hours.toFixed(0).padStart(2, "0")}
                </span>
                <span className={styles.smallText}>{countdownLoc.abbrHour}</span>
              </div>
              <div className={`${styles.smallContainer} ${styles.container}`}>
                <span className={styles.smallNumber}>
                  {minutes.toFixed(0).padStart(2, "0")}
                </span>
                <span className={styles.smallText}>{countdownLoc.abbrMinute}</span>
              </div>
              <div className={`${styles.smallContainer} ${styles.container}`}>
                <span className={styles.smallNumber}>
                  {seconds.toFixed(0).padStart(2, "0")}
                </span>
                <span className={styles.smallText}>{countdownLoc.abbrSecond}</span>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Countdown;